import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { TFunction } from 'i18next'

export const getHeadingAndCreatedAtProps = (notification: Notification, t: TFunction) => ({
    heading: t(`notification.type.${notification.type}`),
    createdAt: notification.createdAt as number,
})
